import React from 'react';
import { Classable, HasChildren } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { WARM_GREY, PageContextDefinition, UiConfig, UiProvider, useModal } from '@shapeable/ui';
import { LayoutShell, SiteFooterLayout } from '@shapeable/ui';
import * as pageLayouts from './page-layouts';
import * as sliceLayouts from './slice-layouts';
import { LANG_STRINGS } from '../lang';
import { GREEN, LayoutStyles, themeOverrides, VERY_LIGHT_BROWN } from '../theme';
import { LinkPillarCard } from './entities/link-pillar-card';
import { ContactUsIframeEmbed } from './elements/contact-us-iframe-embed';


export type LayoutPropTypes = Classable & HasChildren & {
  path?: string;
  data?: any;
  pageContext?: PageContextDefinition;
};

const LayoutDefaultProps: LayoutPropTypes = {
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${LayoutStyles};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `,
});

const BodyStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});

// -------- Components -------->

const My = {
  Container: styled(LayoutShell)`${ContainerStyles}`,
  Body: styled.div`${BodyStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const Layout: React.FC<LayoutPropTypes> = (props) => {
  const { className, children } = props;

  const modal = useModal();

  const onHeaderButtonClick = (slug: string) => {
    if (slug === 'contact-us-iframe-button') {
      modal?.show(<ContactUsIframeEmbed />, { color: '#000000', title: 'Contact Us', opacity: 0.5 });
    }
  }

  const uiConfig: UiConfig = {
    layouts: { pageLayouts, sliceLayouts, defaultPageLayout: pageLayouts.PageLayoutDefault },
    langStrings: LANG_STRINGS,
    theme: themeOverrides,
    header: {
      variant: 'overlay',
      onHeaderButtonClick,
    },
    menuBar: {
      // color: 'light',
      // buttonColor: 'light',
      // buttonHoverColor: 'dark',
      // backgroundColor: YELLOW_DARK,
      // isInverted: true,
    },
    entity: {
      cards: {
        Link: LinkPillarCard,
      }
    },
    componentProps: {
      SlideControls: {
        colors: {
          background: GREEN,
        },
        arrowColors: {
          hover: {
            fill: VERY_LIGHT_BROWN,
          }
        }
      },
      SiteMenuBar: {
        colors: {
          background: GREEN,
        }
      },
      SiteFooterLayout: {
        colors: {
          background: VERY_LIGHT_BROWN,
          // dark: {
          //   background: BLUE,
          // }
        }
      },
    }
  }

  return (
    <UiProvider value={uiConfig}>
      <My.Container
        id="#container"
        className={className}
        includeTooltip
        tooltipProps={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <My.Body>
          {children}
        </My.Body>
        <My.Footer backgroundColor={VERY_LIGHT_BROWN} />
      </My.Container>
    </UiProvider>
  );
  
};

Layout.defaultProps = LayoutDefaultProps;

